// jshint esversion: 8
export default (data, id) => Array.isArray(data) ?
  data.findIndex(item => item.id === id) : undefined;
